import { gql } from "@apollo/client";
export const CHALLENGE_QUERY = gql `
  query Challenge($request: ChallengeRequest!) {
    challenge(request: $request) {
      text
    }
  }
`;
export const AUTHENTICATE_MUTATION = gql `
  mutation Authenticate($request: SignedAuthChallenge!) {
    authenticate(request: $request) {
      accessToken
      refreshToken
    }
  }
`;
export const ProfileFields = gql `
  fragment ProfileFields on Profile {
    id
    name
    handle
    bio
    ownedBy
    attributes {
      key
      value
    }
    picture {
      ... on MediaSet {
        original {
          url
        }
      }
      ... on NftImage {
        uri
      }
    }
    coverPicture {
      ... on MediaSet {
        original {
          url
        }
      }
    }
    stats {
      totalFollowers
      totalFollowing
      totalPosts
      totalComments
      totalMirrors
    }
    followModule {
      __typename
    }
  }
`;
export const USER_PROFILES_QUERY = gql `
  query UserProfiles($ownedBy: [EthereumAddress!]) {
    profiles(request: { ownedBy: $ownedBy }) {
      items {
        ...ProfileFields
        isDefault
        dispatcher {
          canUseRelay
        }
      }
    }
    userSigNonces {
      lensHubOnChainSigNonce
    }
  }
  ${ProfileFields}
`;
export const FOLLOWING = gql `
  query Following($request: FollowingRequest!) {
    following(request: $request) {
      items {
        profile {
          ...ProfileFields
          isFollowedByMe
          __typename
        }
        totalAmountOfTimesFollowing
        __typename
      }
      pageInfo {
        next
        totalCount
        __typename
      }
      __typename
    }
  }
  ${ProfileFields}
`;
export default {
    CHALLENGE_QUERY,
    AUTHENTICATE_MUTATION,
    USER_PROFILES_QUERY,
    FOLLOWING,
};
